import React, { forwardRef, ComponentProps } from 'react';

import Icon, { generateRenderedIcon, IconWithRender } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.717 2H5.182a2.377 2.377 0 0 0-2.379 2.37v7.26A2.377 2.377 0 0 0 5.182 14h5.636a2.377 2.377 0 0 0 2.379-2.37V5.482L9.717 2Zm2.148 9.63a1.047 1.047 0 0 1-1.047 1.039H5.182a1.047 1.047 0 0 1-1.047-1.039V4.37a1.047 1.047 0 0 1 1.047-1.04h3.923v2.76h2.76v5.54Z M8.908 7.074 7.577 5.742h-.003a.67.67 0 0 0-.938 0L5.304 7.074a.667.667 0 0 0 .47 1.136h2.664a.658.658 0 0 0 .612-.41.636.636 0 0 0 .053-.257.698.698 0 0 0-.195-.47Z M5.308 9.792l1.331 1.332h.003a.67.67 0 0 0 .938 0l1.332-1.332a.667.667 0 0 0-.47-1.136H5.777a.658.658 0 0 0-.612.408.636.636 0 0 0-.053.258.698.698 0 0 0 .195.47Z';

const draw24px =
  'M9.694 7.075a.761.761 0 0 1 .54.22l2.54 2.65a.732.732 0 0 1 .21.52.791.791 0 0 1-.24.54.76.76 0 0 1-1.06 0l-1.24-1.3v6l1.26-1.28a.75.75 0 0 1 1.06 0 .712.712 0 0 1 .22.54c0 .194-.075.38-.21.52l-2.55 2.58a.743.743 0 0 1-.25.17.732.732 0 0 1-.58 0 .854.854 0 0 1-.25-.17l-2.53-2.64a.75.75 0 1 1 1.09-1l1.22 1.28v-6l-1.25 1.29a.79.79 0 0 1-1.07 0 .761.761 0 0 1 0-1.06l2.53-2.63a.737.737 0 0 1 .262-.151c.112-.038.197-.086.298-.08Z M15.015 1.895l5.66 5.74v10.73a3.75 3.75 0 0 1-3.76 3.74h-9.9a3.77 3.77 0 0 1-3.69-3.76V5.605a3.76 3.76 0 0 1 3.8-3.71h7.89Zm-7.93 1.47a2.25 2.25 0 0 0-2.25 2.26v12.74a2.27 2.27 0 0 0 2.25 2.26h9.9a2.24 2.24 0 0 0 2.25-2.24v-9.74h-5.26v-5.28h-6.89Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DocumentFitHeightIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'documentFitHeight')) as IconWithRender;

DocumentFitHeightIcon.displayName = 'documentFitHeightIcon';
DocumentFitHeightIcon.propTypes = Icon.propTypes;
DocumentFitHeightIcon.renderIcon = (props) => (
  <DocumentFitHeightIcon {...props} />
);

export default DocumentFitHeightIcon;
